import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  Button,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import BootstrapTable from "react-bootstrap-table-next"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { CSVExport } from "react-bootstrap-table2-toolkit"
//import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { withRouter } from "react-router-dom"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"

import { isEmpty } from "lodash"
import { ToastContainer } from "react-toastify"
import ButtonSpinner from "components/ButtonSpinner"
import * as obsAction from "../../store/bWFuYWdlLW9icw/actions"
import * as inventoryAction from "../../store/aW52ZW50b3J5TGlzdA/actions"

const InventoryList = (props) => {
  const { SearchBar } = Search
  const { dispatch, searchBtnStyle } = props

  const title = "Inventory List"

  //Export downlaod options
  const { ExportCSVButton } = CSVExport

  const update = useSelector((specificstate) => specificstate.inventoryList)
  console.log("update is", update)
  useEffect(() => {
    dispatch(inventoryAction.loadRecordsMetaData())
    dispatch(inventoryAction.loadRecords())
    dispatch(obsAction.loadEmployee())
  }, [])

  //State reducer details
  const { recordsMetaData = {}, records = [] } = update

  const employeeUpdate = useSelector((state) => state.manageobs)
  const { employee_list = [] } = employeeUpdate

  console.log(recordsMetaData, "recordMetaData")
  console.log(records, "records")

  //Handle Change
  const [serialNo, setSerialNo] = useState("")
  const [mode, setMode] = useState([])
  const [equipmentType, setEquipmentType] = useState([])
  const [equipmentBrand, setEquipmentBrand] = useState([])
  const [equipmentProduct, setEquipmentProduct] = useState([])
  const [salesAgent, setSalesAgent] = useState([])
  const [btnLoader, setBtnLoader] = useState(false)

  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const agentOptions = createOptions(employeeList)

  const handleApply = () => {
    var searchAgent = salesAgent && salesAgent ? salesAgent.empCode : ""
    var searchSerialNo = serialNo && serialNo ? serialNo : ""
    var searchMode = mode && mode ? mode.value : ""
    var searchType =
      equipmentType && equipmentType.value ? equipmentType.value : ""
    var searchBrand =
      equipmentBrand && equipmentBrand.value ? equipmentBrand.value : ""
    var searchProduct =
      equipmentProduct && equipmentProduct.value ? equipmentProduct.value : ""

    var searchFilter = {}
    if (searchAgent) {
      searchFilter.empCode = searchAgent
    }
    if (searchMode) {
      searchFilter.mode = searchMode
    }
    if (searchSerialNo) {
      searchFilter.serialNumber = searchSerialNo
    }
    if (searchType) {
      searchFilter.equipmentTypeId = searchType
    }
    if (searchBrand) {
      searchFilter.equipmentBrandId = searchBrand
    }
    if (searchProduct) {
      searchFilter.productVersionId = searchProduct
    }

    dispatch(inventoryAction.loadRecords(searchFilter))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }
  //table data

  let slNo = 0
  const equipmentTable = !isEmpty(records)
    ? records.map((data) => {
        slNo = slNo + 1
        // console.log(data, "equipment from mapped list")
        // const equipmentCount =
        //   !isEmpty(equipment) &&
        //   equipment.details &&
        //   equipment.details.length > 0
        //     ? equipment.details.length
        //     : 0

        // console.log(equipmentCount, "equipmentCount")
        //const BrandName=
        return {
          sNo: slNo,
          employeeCode: data.empCode,
          empId: data.empId,
          employeeName: data.empName,
          equipmentBrandId: data.equipmentBrandId,
          brandName: data.equipmentBrandName,
          equipmentCode: data.equipmentCode,
          equipmentId: data.equipmentId,
          equipmentTypeId: data.equipmentTypeId,
          equipmentType: data.equipmentTypeName,
          mode: data.mode,
          notes: data.notes,
          productVersionId: data.productVersionId,
          productName: data.productVersionName,
          serialNumber: data.serialNumber,
          _id: data.employeeEquipmentId,
          
        }
      })
    : []
  console.log(equipmentTable, "equipmentTable")
  //table columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "employeeCode",
      text: "Employee Code",
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "employeeName",
      text: "Employee Name",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "mode",
      text: "Mode",
      sort: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "equipmentType",
      text: "Equipment Type",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },

    {
      dataField: "brandName",
      text: "Brand",
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "productName",
      text: "Product",

      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "equipmentCode",
      text: "Equipment Code",

      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "serialNumber",
      text: "Serial Number",
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "notes",
      text: "Notes",
      headerStyle: {
        minWidth: "140px",
      },
    },
  ]

  const options = {
    sizePerPage: 10,
    // totalSize: 0, // replace later with size(customers),
    totalSize: equipmentTable.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  const resetFormDetails = () => {
    setMode([])
    setSalesAgent([])
    setSerialNo("")
    setEquipmentBrand([])
    setEquipmentProduct([])
    setEquipmentType([])
    dispatch(inventoryAction.loadRecords())
  }
  //fuse options for venue(autocomplete field)
  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  const modeOptions = [
    {
      label: "ADMIN",
      value: "ADMIN",
    },
    {
      label: "HR",
      value: "HR",
    },
    {
      label: "PHOTOGRAPHY",
      value: "PHOTOGRAPHY",
    },
    {
      label: "IT",
      value: "IT",
    },
    {
      label: "VERMILION",
      value: "VERMILION",
    },
    {
      label: "DIVINE",
      value: "DIVINE",
    },
  ]

  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"HRMS"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Mode"}
                        </Label>
                      </div>
                      <Select
                        name="mode"
                        value={mode}
                        onChange={(e) => setMode(e)}
                        options={modeOptions}
                        placeholder="Select Mode"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Equipment Type"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentType"
                        value={equipmentType}
                        onChange={(e) => setEquipmentType(e)}
                        options={
                          recordsMetaData ? recordsMetaData.typeOptions : []
                        }
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 11,
                          }),
                        }}
                        placeholder="Select Equipment"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Equipment Brand"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentBrand"
                        value={equipmentBrand}
                        onChange={(e) => setEquipmentBrand(e)}
                        options={
                          recordsMetaData ? recordsMetaData.brandOptions : []
                        }
                        placeholder="Select Equipment Brand"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Product Version"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentProduct"
                        value={equipmentProduct}
                        onChange={(e) => setEquipmentProduct(e)}
                        options={
                          recordsMetaData ? recordsMetaData.productOptions : []
                        }
                        placeholder="Select Product Version"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Serial No"}
                        </Label>
                      </div>
                      <Input
                        name="serialNo"
                        value={serialNo}
                        onChange={(e) => setSerialNo(e.target.value)}
                        placeholder="Select Serial No"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Employee"}</Label>
                      </div>
                      <ReactSearchAutocomplete
                        name="salesAgent"
                        items={agentOptions}
                        value={salesAgent}
                        type="autoComplete"
                        resultStringKeyName="label"
                        showIcon={false}
                        onSelect={(e) => setSalesAgent(e)}
                        onChange={(e) => setSalesAgent(e.target.value)}
                        placeholder="Enter Sales Agent"
                        fuseOptions={fuseOptions} // Search on both fields
                        styling={{
                          height: "34px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          boxShadow: "none",
                          hoverBackgroundColor: "#E40D8C",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Courier",
                          iconColor: "green",
                          clearIconMargin: "3px 8px 0 0",
                          zIndex: 10,
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          onClick={() => resetFormDetails()}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="button"
                          onClick={() => handleApply()}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <PaginationProvider
                  pagination={paginationFactory(options)}
                  keyField="_id"
                  columns={columns}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                      keyField="_id"
                      data={equipmentTable}
                      columns={columns}
                      search
                      exportCSV={{
                        onlyExportFiltered: true,
                        exportAll: false,
                      }}
                    >
                      {(props) => (
                        <div>
                          <Col md="12" xl="12" lg="12" sm="12" xs="12">
                            <Row className="d-flex flex-row">
                              <Col className="mb-3" md="4">
                                <div className="d-flex flex-row">
                                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                    <div
                                      className="position-relative mt-7"
                                      style={searchBtnStyle || null}
                                    >
                                      <SearchBar {...props.searchProps} />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </div>{" "}
                              </Col>
                              <Col>
                                <ExportCSVButton
                                  className="border float-right mx-10"
                                  style={{
                                    float: "right",
                                    backgroundColor: "#e40d8c",
                                    color: "#ffffff",
                                  }}
                                  {...props.csvProps}
                                >
                                  Download{" "}
                                </ExportCSVButton>{" "}
                              </Col>
                              <Col md="12" lg="12" xl="12" sm="12" xs="12">
                                <BootstrapTable
                                  {...props.baseProps}
                                  responsive
                                  striped={true}
                                  bordered={true}
                                  columns={columns}
                                  {...paginationTableProps}
                                />
                              </Col>
                            </Row>
                            <Row
                              style={{ marginTop: "5px" }}
                              className="align-items-md-center mt-30"
                            >
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline d-flex flex-row">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginTop: "8px",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    <PaginationTotalStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="text-md-right ms-auto"
                                  style={{ zIndex: 0 }}
                                >
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </PaginationProvider>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}
InventoryList.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  csvProps: PropTypes.any,
  //isInvalid:PropTypes.any
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InventoryList)
)
